import React from 'react';
import TextInfo, {
  DISPLAY,
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';

import {
  normalizeSummaryWithWeight,
} from '../../../../../utils/productUtils';
import {
  calculateBackgroundColorFeature, getBorderShape,
} from '../../../Utils/index';

export const ProductFeatureDetailContent = ({
  aggr, hideColors, variant, hiredProductWeights, dicRepoProductWeights,
}) => {
  let normalizedSumaryWithWeight = null;
  if (aggr && aggr.summary) {
    normalizedSumaryWithWeight = normalizeSummaryWithWeight(aggr.summary);
  }
  const getWeights = (eachSummary) => {
    let hiredWeight;
    let defaultWeight;
    let commerInfoKey;
    if (eachSummary && eachSummary.alias) {
      commerInfoKey = eachSummary.alias.includes(
        ' '
      )
        ? eachSummary.alias.split(' ')[0]
        : eachSummary.alias;
      hiredWeight = hiredProductWeights
        ? hiredProductWeights[commerInfoKey]
        : null;
      defaultWeight = dicRepoProductWeights
        ? dicRepoProductWeights[commerInfoKey]
        : null;
    }
    return { hiredWeight, defaultWeight }
  }
  return (
    <div className="ProductFeatureDetailContent">
      {normalizedSumaryWithWeight && (
        normalizedSumaryWithWeight.map((eachSummary) => {
          const { hiredWeight, defaultWeight } = getWeights(eachSummary);
          return (
            <li>
              <TextInfo
                text={eachSummary.text}
                kind={KIND_TEXT.PARAGRAPH}
                align={ALIGN.LEFT}
                border={getBorderShape({
                  hiredWeight,
                  defaultWeight,
                  hideColors,
                  variant,
                })}
                display={DISPLAY.BLOCK}
                backgroundColor={calculateBackgroundColorFeature({
                  hiredWeight,
                  defaultWeight,
                  hideColors,
                  variant,
                })
                                  }
                color={COLOR.BLACK}
                size={SIZE.CAPTION2}
                fontType={FONT_TYPE.REGULAR}
              />
            </li>
          )
        }))}
    </div>
  )
}
export default ProductFeatureDetailContent;
